import { createElement, ReactNode } from 'react'
import { appFeatures } from './App.features'
import { AppStoreProvider } from './store/AppStore.provider'

export function AppProviders({ children }: { children: ReactNode }) {
  const providers = appFeatures
    .filter((feature) => !!feature.provider)
    .map((feature) => feature.provider!)

  return (
    <AppStoreProvider>
      {providers.reduce((memo, provider) => {
        return createElement(provider!, null, memo)
      }, children)}
    </AppStoreProvider>
  )
}
